<template>
  <div class="formDoubledField">
    <component
      :is="getComponent(items.from.type)"
      :key="items.from.name"
      :value="value.from"
      :name="`${name}-${items.from.name}`"
      :type="items.from.type"
      :label="items.from.label"
      :placeholder="items.from.placeholder"
      class="formDoubledField__field"
      @input="onInputFrom"
    />
    <component
      :is="getComponent(items.to.type)"
      :key="items.to.name"
      :value="value.to"
      :name="`${name}-${items.to.name}`"
      :type="items.to.type"
      :label="items.to.label"
      :placeholder="items.to.placeholder"
      class="formDoubledField__field"
      @input="onInputTo"
    />
  </div>
</template>

<script>
import FormField from './FormField';
import FormDatePicker from './FormDatePicker';

export default {
  name: 'FormDoubleField',
  components: {
    FormField,
    FormDatePicker,
  },
  props: {
    name: {
      type: String,
      default: null,
    },
    items: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: () => ({ from: null, to: null }),
    },
  },
  methods: {
    getComponent(type) {
      if (type === 'date') return 'FormDatePicker';
      return 'FormField';
    },
    onInputFrom(value) {
      const nevValue = { ...this.value, from: value };
      this.$emit('input', nevValue);
      this.$emit('emitObject', { name: this.name, value: nevValue });
    },
    onInputTo(value) {
      const nevValue = { ...this.value, to: value };
      this.$emit('input', nevValue);
      this.$emit('emitObject', { name: this.name, value: nevValue });
    },
  },
};
</script>

<style lang="scss">
.formDoubledField {
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include rwd('large-phone') {
    flex-direction: column;
  }

  &__field {
    flex: 0 0 50%;
    position: relative;

    @include rwd('large-phone') {
      flex: 0 0 100%;
      width: 100%;
    }

    &:first-of-type {
      padding-right: 1rem;

      @include rwd('small-tablet') {
        padding-right: 0.5rem;
      }

      @include rwd('large-phone') {
        margin-bottom: 1.5rem;
        padding-right: 0;
      }

      &:after {
        content: '';
        position: absolute;
        background-color: $cAddLight;
        width: 1rem;
        height: 1px;
        top: calc(50% + 0.5rem);
        left: calc(100% - 0.5rem);
      }
    }

    &:last-of-type {
      padding-left: 1rem;

      @include rwd('small-tablet') {
        padding-left: 0.5rem;
      }

      @include rwd('large-phone') {
        padding-left: 0;
      }
    }
  }
}
</style>
